import http from 'utils/http';
import React, { useEffect, useState } from 'react';
import '../style.css';
import { DownOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { Breadcrumbs } from '../../../components/Atom/breadcumbs';
import { notification, Radio, Modal, Button, Space, Tooltip, Table, Switch, Form, Checkbox, Collapse, Skeleton, Empty } from 'antd';
import { formatAmount, checkUserPermissions, isoToFormattedDateString, getFormattedDateForApiLogs } from 'utils/services';
import ShortenId from 'components/Atom/ShortenId';
import StatusTag from 'components/Atom/StatusTag';
import Input from 'components/Atom/Input';
import { useNavigate, useLocation } from 'react-router-dom';
import { USER_ROLES, TIMEZONES, theme } from 'utils/constant';
import { useQuery, useQueryClient } from 'react-query';
import moment from 'moment';
import { JSONTree } from 'react-json-tree';
import { formatInTimeZone } from 'date-fns-tz';
import {
  cancelSubscription,
  resumeSubscription,
  pauseSubscription,
  payInvoice,
  paymentRefund,
  failInvoicesTag,
  skipSubscription,
  unskipSubscription,
  getSubscriptionApiLogs,
  getSingleSubscription,
  proratedInvoicesStatus,
  RejectInvoice,
  rescheduledInvoice,
} from 'api/subscriptions';
import DateTimePicker from 'components/Atom/DateTimePicker';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { ResetButton } from '../../../components/Atom/Button';
import CopyToClipboardButton from 'components/CopyToClipboardButton';
import LoadingSkeleton from '../../../components/Skeleton/index';
const { Panel } = Collapse;

export const ViewSubscriptionDetails = () => {
  const [cancelSubscriptionModal, setCancelSubscriptionModal] = useState(false);
  const [resumeSubscriptionModal, setResumeSubscriptionModal] = useState(false);
  const [pauseSubscriptionModal, setPauseSubscriptionModal] = useState(false);
  const [paymentRetryModal, setpaymentRetryModal] = useState(false);
  const [rejectInvoiceModal, setRejectInvoiceModal] = useState(false);
  const [payModal, setPayModal] = useState(false);
  const [refundModal, setRefundModal] = useState(false);
  const [skipSubscriptionModal, setSkipSubscriptionModal] = useState(false);
  const [processNowSubsModal, setProcessNowSubsModal] = useState(false);
  const [rescheduledSubsModal, setRescheduledSubsModal] = useState(false);
  const [unskipSubscriptionModal, setUnskipSubscriptionModal] = useState(false);
  const [isSubscriptionCanceling, setIsSubscriptionCanceling] = useState(false);
  const [isSubscriptionResuming, setIsSubscriptionResuming] = useState(false);
  const [isSubscriptionPausing, setIsSubscriptionPausing] = useState(false);
  const [isPaymentRetrying, setIsPaymentRetrying] = useState(false);
  const [isPaymentRejecting, setisPaymentRejecting] = useState(false);
  const [isPaying, setIsPaying] = useState(false);
  const [isRescheduling, setIsRescheduling] = useState(false);
  const [isRefunding, setIsRefunding] = useState(false);
  const [isSubscriptionSkiping, setIsSubscriptionSkiping] = useState(false);
  const [isSubscriptionUnskiping, setIsSubscriptionUnskiping] = useState(false);
  const [skipInvoiceValue, setSkipInvoiceValue] = useState('');
  const [unskipInvoiceValue, setUnskipInvoiceValue] = useState({ date: '', id: '' });
  const [overrideValue, setOverrideValue] = useState(false);
  const [invoiceId, setInvoiceId] = useState(false);
  const [errorOwnership, setErrorOwnership] = useState('');
  const [apiLogs, setApiLogs] = useState(null);
  const [webhookLogs, setWebhookLogs] = useState(null);
  const [triggerWebhook, setTriggerWebhook] = useState(false);
  const store = useSelector((state) => state.company.store);
  const navigate = useNavigate();
  const [updatePrice, setUpdatePrice] = useState(false);
  const [selectedCycle, setSelectedCycle] = useState('retain');
  const location = useLocation();
  const { id } = useParams();
  const queryClient = useQueryClient();

  const fetchSubscriptionData = async () => {
    const response = await getSingleSubscription(location?.state?.record?.store_id || store?._id, id || location?.state?.record?.subscription_id);
    return response?.data?.data || null;
    /*   if (data?.unpaid_invoices?.length) {
      handleFailInvoicesTag(data);
    }
    if (data) {
      subscriptionApiLogs(data);
    } 
    return data; */
  };
  const {
    data: record,
    refetch,
    isLoading,
    isFetching,
  } = useQuery(`subscriptions_${id || location?.state?.record?.subscription_id}`, fetchSubscriptionData, {
    enabled: false,
    manual: true,
  });
  const {
    data: proratedInvoicesRecord,
    refetch: refetchInvoices,
    isLoading: isLoadingInvoices,
    isFetching: isFetchingInvoices,
  } = useQuery(`proration_Invoices_${id || location?.state?.record?.subscription_id}`, () => getProratedInvoices(record), {
    enabled: false,
    manual: true,
  });
  useEffect(() => {
    refetch();
  }, [store]);

  useEffect(() => {
    if (record) {
      subscriptionApiLogs(record);
    }
    if (record?.unpaid_invoices?.length) {
      handleFailInvoicesTag(record);
    }
    if (record?.updated_prorated_invoices?.length) {
      refetchInvoices();
    }
  }, [record]);

  const getProratedInvoices = async (record) => {
    const invoiceIds = record?.updated_prorated_invoices?.map((invoice) => invoice?.invoice_id);
    const payload = {
      prorated_invoices: invoiceIds,
    };
    const response = await proratedInvoicesStatus(record?.store_id, payload);
    return response?.data?.data || null;
  };

  const subscriptionApiLogs = async (data) => {
    const subscription_id = data?.subscription_id;
    const storeId = data?.store_id;
    const { start_date, end_date } = getFormattedDateForApiLogs(data);
    const response = await getSubscriptionApiLogs(subscription_id, storeId, start_date, end_date);
    if (response?.data?.success) {
      setApiLogs(response?.data?.data?.logs || null);
      setWebhookLogs(response?.data?.data?.webhook || refund?.webhook_data || null);
    }
  };

  const onChange = () => {
    setOverrideValue((prevValue) => {
      return !prevValue;
    });
  };
  const handleRadioChange = (e) => {
    setSelectedCycle(e?.target?.value);
  };
  function dateComparisionWithCurrent(date) {
    const newdate = new Date();
    let timezoneOffset = newdate?.getTimezoneOffset();
    const currentDate = new Date(newdate?.getTime() - timezoneOffset * 60000)?.toISOString();
    const dateObj1 = new Date(date);
    const dateObj2 = new Date(currentDate);
    return dateObj1 <= dateObj2;
  }
  const breadcrumbProps = {
    breadcrumbs: [
      {
        name: 'XPay',
        href: '/xpay',
      },
      {
        name: 'Subscriptions',
        href: '/subscriptions',
        data: {
          id: location?.state?.id,
          isRedirection: true,
          searchValue: location?.state?.searchValue,
          filtersData: location?.state?.filtersData,
        },
      },
      {
        name: <ShortenId value={id || location?.state?.id || 'Not Found'} />,
      },
    ],
  };
  const columns = [
    {
      title: 'Date',
      render: (value) => value?.date,
      key: 'date',
    },
    {
      title: 'Hour',
      render: (value) => value?.hour,
      key: 'hour',
    },
    {
      title: 'Minute',
      render: (value) => value?.minute,
      key: 'minute',
    },
  ];
  const PaidInvoiceColumn = [
    {
      title: 'Invoice Id',
      render: (value) => (
        <div className='flex items-center gap-1'>
          <ShortenId value={value?.invoice_id} />
          {value?.state && <StatusTag tag={value?.state?.replace?.(/_/g, ' ')} />}
        </div>
      ),
      key: 'invoice_id',
    },
    {
      title: 'Date',
      render: (value) => (value?.date ? isoToFormattedDateString(value?.date) : 'N/A'),
      key: 'date',
    },
    ...(checkUserPermissions([USER_ROLES.XPAY_ADMIN, USER_ROLES.XPAY_RESTRICTED_ADMIN, USER_ROLES.XPAY_SUBSCRIPTION_USER])
      ? [
          {
            title: 'Action',
            key: 'action',
            render: (data, index) => {
              if (data?.auth_risk_declined && record?.state == 'paid') {
                return (
                  <div key={index} className='flex items-center gap-2'>
                    <div
                      type='primary'
                      className='table-action-btn'
                      onClick={() => {
                        setRejectInvoiceModal(true);
                        setInvoiceId(data?.invoice_id);
                      }}
                      style={{ cursor: 'pointer', padding: '3px 7px' }}>
                      Reject Payment
                    </div>
                  </div>
                );
              }
              return null;
            },
          },
        ]
      : []),
  ];
  const invoicesColumns = [
    {
      title: 'Invoice Id',
      render: (value) => <ShortenId value={value?.invoice_id} />,
      key: 'invoice_id',
    },
    {
      title: 'Date',
      render: (value) => (value?.date ? isoToFormattedDateString(value?.date) : 'N/A'),
      key: 'date',
    },
  ];

  const proratedInvoicesColumns = [
    {
      title: 'Invoice Id',
      render: (value) => <ShortenId value={value?.invoice_id} />,
      key: 'invoice_id',
    },
    {
      title: 'Previously Paid Invoice',
      render: (value) => <ShortenId value={value?.previously_paid_invoice} />,
      key: 'previously_paid_invoice',
    },
    {
      title: 'Type',
      render: (value) => value?.type,
      key: 'type',
    },
    {
      title: 'Time',
      render: (value) => (value?.time ? isoToFormattedDateString(value?.time) : 'N/A'),
      key: 'time',
    },
    ...(checkUserPermissions([USER_ROLES.XPAY_ADMIN, USER_ROLES.XPAY_RESTRICTED_ADMIN, USER_ROLES.XPAY_SUBSCRIPTION_USER])
      ? [
          {
            title: 'Action',
            key: 'action',
            render: (data, index) => {
              const matchedInvoice = proratedInvoicesRecord?.find((invoice) => invoice?.invoice_id === data?.invoice_id);
              const isMatchedState = (matchedInvoice?.state === 'paid' && data?.type === 'payment') || (matchedInvoice?.state === 'refunded' && data?.type === 'refund');
              return (
                <div key={index} className='flex items-center gap-2 proration_tag'>
                  {isMatchedState ? (
                    <span>{<StatusTag tag={matchedInvoice?.state} />}</span>
                  ) : (
                    <div
                      type='primary'
                      className='table-action-btn'
                      onClick={() => {
                        if (data?.type === 'payment') {
                          setPayModal(true);
                        } else {
                          setRefundModal(true);
                        }
                        setInvoiceId(data?.invoice_id);
                      }}
                      style={{ cursor: 'pointer', padding: '3px 7px', textAlign: 'center', width: '65px' }}>
                      {data?.type === 'payment' ? 'Pay' : 'Refund'}
                    </div>
                  )}
                </div>
              );
            },
          },
        ]
      : []),
  ];

  const expandedRowRender = (record) => {
    const details = JSON?.parse(record?.details || '{}');
    return (
      <div style={{ width: '100%', borderCollapse: 'collapse' }} className='proration-detail'>
        <h1 style={{ fontWeight: 'bold' }}>Details</h1>
        <JSONTree data={details} theme={theme} invertTheme={true} hideRoot={true} />
      </div>
    );
  };

  const unPaidInvoicesColumns = [
    {
      title: 'Invoice Id',
      render: (value) => <ShortenId value={value?.invoice_id} />,
      key: 'invoice_id',
    },
    {
      title: 'Date',
      render: (value) => (value?.date ? isoToFormattedDateString(value?.date) : 'N/A'),
      key: 'date',
    },
    {
      title: 'Error Ownership',
      render: (value) => {
        if (errorOwnership) {
          const ownership = errorOwnership?.find((item) => item?.invoice_id === value?.invoice_id)?.ownership;
          return ownership ? <StatusTag tag={ownership} color='error' /> : 'N/A';
        } else {
          return 'N/A';
        }
      },
      key: 'ownership',
    },
    ...(checkUserPermissions([USER_ROLES.XPAY_ADMIN, USER_ROLES.XPAY_RESTRICTED_ADMIN, USER_ROLES.XPAY_SUBSCRIPTION_USER])
      ? [
          {
            title: 'Action',
            key: 'action',
            render: (data, index) => {
              return (
                <div key={index} className='flex items-center gap-2'>
                  <div
                    type='primary'
                    className='table-action-btn'
                    onClick={() => {
                      setpaymentRetryModal(true);
                      setInvoiceId(data?.invoice_id);
                    }}
                    style={{ cursor: 'pointer', padding: '3px 7px' }}>
                    Retry Payment
                  </div>
                </div>
              );
            },
          },
        ]
      : []),
  ];
  const skipInvoicesColumns = [
    {
      title: 'Invoice Id',
      render: (value) => <ShortenId value={value?.invoice_id} />,
      key: 'invoice_id',
    },
    {
      title: 'Date',
      render: (value) => (value?.date ? isoToFormattedDateString(value?.date) : '-'),
      key: 'date',
    },
    ...(checkUserPermissions([USER_ROLES.XPAY_ADMIN, USER_ROLES.XPAY_RESTRICTED_ADMIN, USER_ROLES.XPAY_SUBSCRIPTION_USER]) && !(record?.is_usage_based && !record?.payment?.token)
      ? [
          {
            title: 'Action',
            key: 'action',
            render: (data, index) => {
              return (
                <div key={index} className='flex items-center gap-2'>
                  <div
                    type='primary'
                    className='table-action-btn'
                    onClick={() => {
                      setProcessNowSubsModal(true);
                      setInvoiceId(data?.invoice_id);
                    }}
                    style={{ cursor: 'pointer' }}>
                    Process Now
                  </div>
                  {['paid', 'manually paid'].includes(record?.state) && (
                    <div
                      type='primary'
                      className='table-action-btn'
                      onClick={() => {
                        setRescheduledSubsModal(true);
                        setInvoiceId(data?.invoice_id);
                      }}
                      style={{ cursor: 'pointer' }}>
                      Reschedule
                    </div>
                  )}
                  {!record?.is_usage_based && (
                    <div
                      type='primary'
                      className='table-action-btn'
                      onClick={() => {
                        setSkipSubscriptionModal(true);
                        setSkipInvoiceValue(data?.invoice_id);
                      }}
                      style={{ cursor: 'pointer' }}>
                      Skip
                    </div>
                  )}
                </div>
              );
            },
          },
        ]
      : []),
  ];
  const productsColumns = [
    {
      title: 'Name',
      render: (value) => value?.name || '-',
      key: 'name',
    },
    {
      title: 'Product Id',
      render: (value) => <ShortenId value={value?.product_id} />,
      key: 'product_id',
    },
    {
      title: 'Price',
      render: (value) => formatAmount(value?.price, record?.payment?.currency) || '-',
      key: 'price',
    },
    {
      title: 'Quantity',
      render: (value) => value?.quantity || '-',
      key: 'quantity',
    },
  ];
  const unskipInvoicesColumns = [
    {
      title: 'Invoice Id',
      render: (value) => <ShortenId value={value?.invoice_id} />,
      key: 'invoice_id',
    },
    {
      title: 'Date',
      render: (value) => (value?.date ? isoToFormattedDateString(value?.date) : '-'),
      key: 'date',
    },
    ...(checkUserPermissions([USER_ROLES.XPAY_ADMIN, USER_ROLES.XPAY_RESTRICTED_ADMIN, USER_ROLES.XPAY_SUBSCRIPTION_USER]) && !record?.is_usage_based
      ? [
          {
            title: 'Action',
            key: 'action',
            render: (data, index) => {
              return (
                <div key={index} className='flex items-center gap-2'>
                  <div
                    type='primary'
                    className='table-action-btn'
                    onClick={() => {
                      setUnskipSubscriptionModal(true);
                      setUnskipInvoiceValue({ date: data?.date, id: data?.invoice_id });
                    }}
                    style={{ cursor: 'pointer' }}>
                    unskip
                  </div>
                </div>
              );
            },
          },
        ]
      : []),
  ];
  const time_zone = store?.settings?.timezone || TIMEZONES.PKT;
  const generalInformation = [
    { label: 'Subscription ID', value: <ShortenId value={record?.subscription_id} /> },
    { label: 'Name', value: record?.name || 'N/A' },
    { label: 'Plan ID', value: <ShortenId value={record?.plan_id} /> },
    { label: 'Active', value: record?.active ? 'Yes' : 'No' },
    ...(record?.is_usage_based ? [{ label: 'Usage-Based', value: record?.is_usage_based ? 'Yes' : 'No' }] : []),
    ...(record?.is_usage_based && !record?.payment?.token ? [{ label: 'Tokenless', value: 'Yes' }] : []),
    { label: 'Start Date', value: isoToFormattedDateString(record?.start_date) },
    { label: 'Plan Amount', value: formatAmount(record?.plan_amount, record?.payment?.currency) },
    { label: 'Timezone', value: record?.timezone },
    { label: '', value: <StatusTag tag={record?.state} /> },
    { label: 'Collect Advance', value: record?.collect_advance ? 'Yes' : 'No' },
    { label: 'Creation Time', value: record?.createdAt ? formatInTimeZone(record?.createdAt, time_zone, 'MMM d, yyyy h:mm:ss a') : '-' },
    { label: 'Last Update Time', value: record?.updatedAt ? formatInTimeZone(record?.updatedAt, time_zone, 'MMM d, yyyy h:mm:ss a') : '-' },
  ];

  const onCancelSubmit = async (values) => {
    setIsSubscriptionCanceling(true);
    const { reason } = values;
    const payload = {
      cancellation_reason: reason,
    };
    const response = await cancelSubscription(record?.store_id, record?.subscription_id, payload);
    if (response?.data?.success) {
      setCancelSubscriptionModal(false);
      navigate(`/subscriptions`);
    }
    setIsSubscriptionCanceling(false);
  };

  const handleResumeSubscription = async (id) => {
    setIsSubscriptionResuming(true);
    const payload = {
      billing_cycle: selectedCycle,
    };
    const response = await resumeSubscription(record?.store_id, id, payload);
    if (response?.data?.success) {
      setResumeSubscriptionModal(false);
      navigate(`/subscriptions`);
    }
    setIsSubscriptionResuming(false);
  };

  const handlePauseSubscription = async (id) => {
    const payload = {
      type: 'immediate',
    };
    setIsSubscriptionPausing(true);
    const response = await pauseSubscription(record?.store_id, id, payload);
    if (response?.data?.success) {
      setPauseSubscriptionModal(false);
      navigate(`/subscriptions`);
    }
    setIsSubscriptionPausing(false);
  };
  const handleRetryPayment = async () => {
    const payload = {
      send_payment_link_on_failure: updatePrice,
    };
    setIsPaymentRetrying(true);
    const response = await payInvoice(record?.store_id, invoiceId, payload);
    if (response?.data?.success) {
      setpaymentRetryModal(false);
      queryClient.setQueryData(`subscriptions_${id || location?.state?.record?.subscription_id}`, response?.data?.data?.subscription);
    }
    setIsPaymentRetrying(false);
    if (response?.data?.data?.unpaid_invoices?.length) {
      handleFailInvoicesTag(response?.data?.data);
    }
  };

  const handleRejectPayment = async () => {
    setisPaymentRejecting(true);
    const response = await RejectInvoice(record?.store_id, invoiceId);
    if (response?.data?.success) {
      setRejectInvoiceModal(false);
      queryClient.setQueryData(`subscriptions_${id || location?.state?.record?.subscription_id}`, response?.data?.data?.subscription);
    }
    setisPaymentRejecting(false);
    if (response?.data?.data?.unpaid_invoices?.length) {
      handleFailInvoicesTag(response?.data?.data);
    }
  };

  const handlePay = async () => {
    const payload = {
      send_payment_link_on_failure: updatePrice,
    };
    setIsPaying(true);
    const response = await payInvoice(record?.store_id, invoiceId, payload);
    if (response?.data?.success) {
      setProcessNowSubsModal(false);
      setPayModal(false);
      queryClient.setQueryData(`subscriptions_${id || location?.state?.record?.subscription_id}`, response?.data?.data?.subscription);
    }
    setIsPaying(false);
  };

  const onRescheduledSubmit = async (values) => {
    setIsRescheduling(true);
    const newdate = new Date(values?.rescheduled_Date);
    const timezoneOffset = newdate?.getTimezoneOffset();
    const localISOTime = new Date(newdate?.getTime() - timezoneOffset * 60000)?.toISOString();
    const [date, timeWithMs] = localISOTime?.split('T');
    const [time, msWithZ] = timeWithMs?.split('.');
    const formattedStartDate = `${date}T${time}Z`;
    const payload = {
      dateToBeUpdated: formattedStartDate,
    };
    const response = await rescheduledInvoice(record?.store_id, invoiceId, payload);
    if (response?.data?.success) {
      setRescheduledSubsModal(false);
      queryClient.setQueryData(`subscriptions_${id || location?.state?.record?.subscription_id}`, response?.data?.data);
    }
    setIsRescheduling(false);
  };

  const handleRefund = async () => {
    setIsRefunding(true);
    const response = await paymentRefund(record?.store_id, invoiceId);
    if (response?.data?.success) {
      setRefundModal(false);
      refetchInvoices();
    }
    setIsRefunding(false);
  };
  const handleFailInvoicesTag = async (record) => {
    const invoiceIds = record?.unpaid_invoices?.map((invoice) => invoice?.invoice_id);
    const payload = {
      unpaid_invoices: invoiceIds,
    };
    const response = await failInvoicesTag(record?.store_id, payload);
    if (response?.data?.success) {
      const lastAttemptResult = response?.data?.data?.map((invoice) => {
        const lastPaymentAttempt = invoice?.payment_attempts?.slice(-1)[0];
        return {
          invoice_id: invoice?.invoice_id,
          ownership: lastPaymentAttempt?.payment_intent?.ownership,
        };
      });
      setErrorOwnership(lastAttemptResult);
    }
  };

  const handleSkipSubscription = async (invoiceId) => {
    setIsSubscriptionSkiping(true);
    const payload = {
      type: 'invoice_id',
      invoice_id: skipInvoiceValue,
    };
    const response = await skipSubscription(record?.store_id, invoiceId, payload);
    if (response?.data?.success) {
      setSkipSubscriptionModal(false);
      queryClient.setQueryData(`subscriptions_${id || location?.state?.record?.subscription_id}`, response?.data?.data);
    }
    setIsSubscriptionSkiping(false);
  };

  const handleUnskipSubscription = async (invoiceId) => {
    setIsSubscriptionUnskiping(true);
    const payload = {
      type: 'invoice_id',
      invoice_id: unskipInvoiceValue?.id,
      ...(overrideValue && { override: true }),
    };
    const response = await unskipSubscription(record?.store_id, invoiceId, payload);
    if (response?.data?.success) {
      setUnskipSubscriptionModal(false);
      queryClient.setQueryData(`subscriptions_${id || location?.state?.record?.subscription_id}`, response?.data?.data);
    }
    setIsSubscriptionUnskiping(false);
  };
  const handlePriceChange = (e) => {
    setUpdatePrice(e?.target?.checked);
  };

  const handleWebhookTrigger = async () => {
    setTriggerWebhook(true);
    try {
      const response = await http.get(`/public/v1/subscription/${record?.subscription_id}/webhook?store_id=${record?.store_id}`);
      notification.success({ message: response?.data?.data?.message });
    } catch (err) {
      notification.error({ message: err?.response?.data?.error?.message || err?.response?.data?.message || 'SOMETHING WENT WRONG' });
    }
    setTriggerWebhook(false);
  };

  return (
    <>
      <div className='header-container p-4 custom-sticky'>
        <div className='payment-breadcrums'>
          <div
            className='back-button'
            onClick={() =>
              navigate('/subscriptions', {
                state: {
                  id: location?.state?.id,
                  isRedirection: true,
                  searchValue: location?.state?.searchValue,
                  filtersData: location?.state?.filtersData,
                },
              })
            }>
            <ArrowLeftOutlined /> <span style={{ fontWeight: 600 }}>Back</span>
          </div>
          <span style={{ color: '#8C8C8C' }}>|</span>
          <Breadcrumbs {...breadcrumbProps} />
          <ResetButton onClick={refetch} loading={isFetching} />
        </div>
        <div className='detail-heading mt-4'>Subscription Detail</div>
        <div className='headerPage mt-4' style={{ flexDirection: 'column', alignItems: 'flex-start' }}>
          <div className='payment-message' style={{ display: 'flex' }}>
            {isLoading ? <Skeleton.Input className='status-skeleton' /> : record?.state && <div className='header-tag'>{<StatusTag tag={record?.state} /> || 'N/A'}</div>}
            {isLoading ? (
              <Skeleton.Input className='message-skeleton' />
            ) : (
              record?.state === 'cancelled' &&
              record?.metadata?.cancellation_reason && (
                <div style={{ width: '100%' }}>
                  <div className='message' style={{ padding: '6.2px 12px', marginLeft: '6px', borderRadius: '8px' }}>
                    <span style={{ fontWeight: 'bold' }}>Reason:</span> {record?.metadata?.cancellation_reason}
                  </div>
                </div>
              )
            )}
          </div>
        </div>
      </div>
      <div className='subscription-details logs-details'>
        {isLoading ? (
          <LoadingSkeleton active />
        ) : !record ? (
          store?.isSelected ? (
            <div className='empty-custom-style'>
              <Empty image={Empty?.PRESENTED_IMAGE_SIMPLE} />
            </div>
          ) : (
            <div className='empty-custom-style'>
              <Empty description={'Select store from the drop-down menu above'} />
            </div>
          )
        ) : (
          <>
            <div className='details-section '>
              <div className='heading-section'>
                <h3>Subscription Detail</h3>
              </div>
              <div className='detail-card'>
                {generalInformation?.map((info, index) => (
                  <div key={index} className='detail-value'>
                    <h2>{info?.label}</h2> <span>{info?.value || 'N/A'}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className='details-section'>
              <div className='heading-section'>
                <h3>Customer Details</h3>
              </div>
              <div className='detail-card'>
                <div className='detail-value'>
                  <h2>Name</h2> <span>{record?.customer?.name || 'N/A'}</span>
                </div>
                <div className='detail-value'>
                  <h2>Email</h2> <span>{record?.customer?.email || 'N/A'}</span>
                </div>
                <div className='detail-value'>
                  <h2>Phone</h2> <span>{record?.customer?.phone || 'N/A'}</span>
                </div>
              </div>
            </div>

            <div className='details-section'>
              <div className='heading-section'>
                <h3>Payment Details</h3>
              </div>
              <div className='detail-card'>
                <div className='detail-value'>
                  <h2>Payment Token</h2>{' '}
                  <span>
                    <ShortenId value={record?.payment?.token} />
                  </span>
                </div>
                <div className='detail-value'>
                  <h2>Amount</h2> <span>{formatAmount(record?.payment?.amount, record?.payment?.currency) || 'N/A'}</span>
                </div>
                <div className='detail-value'>
                  <h2>Currency</h2> <span>{record?.payment?.currency || 'N/A'}</span>
                </div>
              </div>
            </div>

            <div className='details-section'>
              <div className='heading-section'>
                <h3>Billing Cycle</h3>
              </div>
              <div className='detail-card'>
                <div className='detail-value'>
                  <h2>Interval</h2> <span>{record?.billing_cycle?.interval || 'N/A'}</span>
                </div>
                <div className='detail-value'>
                  <h2>Every</h2> <span>{record?.billing_cycle?.every || 'N/A'}</span>
                </div>
                <div className='detail-value'>
                  <h2>Total Count</h2> <span>{record?.billing_cycle?.total_count || 'N/A'}</span>
                </div>
              </div>
            </div>

            {record?.is_usage_based && !record?.payment?.token && record?.past_due && (
              <div className='details-section'>
                <div className='heading-section'>
                  <h3>Past Due Reminder</h3>
                </div>
                <div className='detail-card'>
                  <div className='detail-value'>
                    <h2>Type</h2> <span>{record?.past_due?.type || 'N/A'}</span>
                  </div>
                  <div className='detail-value'>
                    <h2>Every</h2> <span>{record?.past_due?.value || 'N/A'}</span>
                  </div>
                </div>
              </div>
            )}

            <div className='details-section'>
              <div className='heading-section'>
                <h3>Billing Anchor Calculations</h3>
              </div>
              {record?.billing_anchor_calculations ? (
                <div className='detail-card'>
                  <div className='detail-value'>
                    <h2>Prorated Amount</h2> <span>{record?.billing_anchor_calculations?.proratedAmount || 'N/A'}</span>
                  </div>
                  <div className='detail-value'>
                    <h2>Start of Cycle</h2>{' '}
                    <span>{record?.billing_anchor_calculations?.startOfCycle ? formatInTimeZone(record?.billing_anchor_calculations?.startOfCycle, time_zone, 'MMM d, yyyy') : '-'}</span>
                  </div>
                  <div className='detail-value'>
                    <h2>Next Cycle</h2> <span>{record?.billing_anchor_calculations?.nextCycle ? formatInTimeZone(record?.billing_anchor_calculations?.nextCycle, time_zone, 'MMM d, yyyy') : '-'}</span>
                  </div>
                  <div className='detail-value'>
                    <h2>Total Cycle Days</h2> <span>{record?.billing_anchor_calculations?.totalCycleDays || 'N/A'}</span>
                  </div>
                  <div className='detail-value'>
                    <h2>Remaining Days</h2> <span>{record?.billing_anchor_calculations?.remainingDays || 'N/A'}</span>
                  </div>
                  <div className='detail-value'>
                    <h2>Daily Amount</h2> <span>{record?.billing_anchor_calculations?.dailyAmount || 'N/A'}</span>
                  </div>
                </div>
              ) : (
                <div className='empty-details'>
                  <div>No Billing Anchor Details Found</div>
                </div>
              )}
            </div>

            <div className='details-section'>
              <div className='heading-section'>
                <h3>Payment Retries Timing</h3>
              </div>
              <div className='table-container'>
                {record?.payment_retries_timing?.length > 0 ? (
                  <Table columns={columns} dataSource={record?.payment_retries_timing} pagination={false} />
                ) : (
                  <div className='empty-details'>
                    {' '}
                    <div>No Retry</div>
                  </div>
                )}
              </div>
            </div>

            <div className='details-section '>
              <div className='heading-section'>
                <h3>Products</h3>
              </div>
              <div className='table-container'>
                {record?.product?.length > 0 ? (
                  <Table columns={productsColumns} dataSource={record?.product} pagination={false} />
                ) : (
                  <div className='empty-details'>
                    {' '}
                    <div>No Product</div>
                  </div>
                )}
              </div>
            </div>

            <div className='details-section '>
              <div className='heading-section'>
                <h3>Scheduled Invoices</h3>
              </div>
              <div className='table-container'>
                {record?.scheduled_invoices?.length > 0 ? (
                  <Table columns={skipInvoicesColumns} dataSource={record?.scheduled_invoices} pagination={false} />
                ) : (
                  <div className='empty-details'>
                    {' '}
                    <div>No Scheduled Invoices</div>
                  </div>
                )}
              </div>
            </div>

            <div className='details-section '>
              <div className='heading-section'>
                <h3>Paused Invoices</h3>
              </div>
              <div className='table-container'>
                {record?.paused_invoices?.length > 0 ? (
                  <Table columns={invoicesColumns} dataSource={record?.paused_invoices} pagination={false} />
                ) : (
                  <div className='empty-details'>
                    {' '}
                    <div>No Paused Invoices</div>
                  </div>
                )}
              </div>
            </div>

            <div className='details-section '>
              <div className='heading-section'>
                <h3>Paid Invoices</h3>
              </div>
              <div className='table-container'>
                {record?.paid_invoices?.length > 0 ? (
                  <Table columns={PaidInvoiceColumn} dataSource={record?.paid_invoices} pagination={false} />
                ) : (
                  <div className='empty-details'>
                    {' '}
                    <div>No Paid Invoices</div>
                  </div>
                )}
              </div>
            </div>

            <div className='details-section'>
              <div className='heading-section'>
                <h3>Proration Invoices</h3>
              </div>
              <div className='table-proration'>
                {record?.updated_prorated_invoices?.length > 0 ? (
                  <Table
                    columns={
                      isLoadingInvoices
                        ? columns.map((column) => {
                            return {
                              ...column,
                              render: () => {
                                return <Skeleton active={true} paragraph={false} key={column.key} />;
                              },
                            };
                          })
                        : proratedInvoicesColumns
                    }
                    dataSource={
                      isLoadingInvoices
                        ? [...Array(record?.updated_prorated_invoices?.length || 5)].map((_, index) => ({
                            key: `key${index}`,
                          }))
                        : record?.updated_prorated_invoices
                    }
                    pagination={false}
                    expandable={
                      !isLoadingInvoices && {
                        expandedRowRender,
                        defaultExpandedRowKeys: [record?.updated_prorated_invoices[0]?.invoice_id],
                      }
                    }
                    rowKey={(e) => e?.invoice_id}
                  />
                ) : (
                  <div className='empty-details'>
                    <div>No Proration Invoice</div>
                  </div>
                )}
              </div>
            </div>

            <div className='details-section '>
              <div className='heading-section'>
                <h3>Skipped Invoices</h3>
              </div>
              <div className='table-container'>
                {record?.skipped_invoices?.length > 0 ? (
                  <Table columns={unskipInvoicesColumns} dataSource={record?.skipped_invoices} pagination={false} />
                ) : (
                  <div className='empty-details'>
                    {' '}
                    <div>No Skipped Invoices</div>
                  </div>
                )}
              </div>
            </div>

            <div className='details-section '>
              <div className='heading-section'>
                <h3>Unpaid Invoices</h3>
              </div>
              <div className='table-container'>
                {record?.unpaid_invoices?.length > 0 ? (
                  <Table columns={unPaidInvoicesColumns} dataSource={record?.unpaid_invoices} pagination={false} />
                ) : (
                  <div className='empty-details'>
                    {' '}
                    <div>No Unpaid Invoices</div>
                  </div>
                )}
              </div>
            </div>
            <Collapse expandIcon={({ isActive }) => <DownOutlined rotate={isActive ? 180 : 0} />} defaultActiveKey={['1']}>
              {webhookLogs && webhookLogs?.length > 0 && (
                <Panel header='Webhook Logs' className='border' key='5'>
                  <div className='webhookLogs'>
                    <Collapse>
                      {webhookLogs?.map((data, index) => {
                        const webhookDisplayData = { ...data };
                        delete webhookDisplayData._id;
                        return (
                          <Panel
                            header={
                              <div className='header-api-log'>
                                <span className='request-type'>{`Webhook Request ${index + 1} `}</span>
                              </div>
                            }
                            className='border'
                            key={`${index}1`}>
                            <div className=''>
                              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <CopyToClipboardButton content={data} />
                              </div>
                              <JSONTree key={index} data={webhookDisplayData} theme={theme} invertTheme={true} hideRoot={true} />
                            </div>
                          </Panel>
                        );
                      })}
                    </Collapse>
                  </div>
                </Panel>
              )}
              {apiLogs?.length > 0 && (
                <Panel header='API Logs' className='border' key='1'>
                  <div className='apiLogs'>
                    <Collapse>
                      {apiLogs?.map((data, index) => {
                        if (data?.response?.encryptionKey) {
                          delete data?.response?.encryptionKey;
                        }
                        return (
                          <Panel
                            header={
                              <div className='header-api-log'>
                                <h1>{data?.end_point_url}</h1>
                                <span className='request-type'>{data?.api_call_name}</span>
                              </div>
                            }
                            className='border'
                            key={`${index}1`}>
                            <div className=''>
                              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <CopyToClipboardButton
                                  content={{
                                    'Request Time': moment(data?.created_at).format('MMM D, YYYY h:mm:ss A'),
                                    'Request Body': data?.payload ?? null,
                                    'Response Body': data?.response ?? null,
                                  }}
                                />
                              </div>
                              <h1 style={{ fontWeight: 'bold' }}>Request Time</h1>
                              <p style={{ margin: '5px 0px' }}>{moment(data?.created_at).format('MMM D, YYYY h:mm:ss A')}</p>
                              <h1 style={{ fontWeight: 'bold', margin: '5px 0px' }}>Request Body</h1>
                              <JSONTree key={`${index}2`} data={data?.payload ?? null} theme={theme} invertTheme={true} hideRoot={true} />
                              <h1 style={{ fontWeight: 'bold', margin: '5px 0px' }}>Response Body</h1>
                              <JSONTree key={`${index}3`} data={data?.response ?? null} theme={theme} invertTheme={true} hideRoot={true} />
                            </div>
                          </Panel>
                        );
                      })}
                    </Collapse>
                  </div>
                </Panel>
              )}
            </Collapse>
          </>
        )}
      </div>
      <Modal
        className='cancel-modal'
        open={cancelSubscriptionModal}
        width={400}
        onCancel={() => {
          setCancelSubscriptionModal(false);
        }}
        footer={false}
        okButtonProps={{ loading: isSubscriptionCanceling }}
        destroyOnClose>
        <header className='font-semibold text-base mb-4'>Cancel Subscription</header>
        <div className='mb-4'>
          Are you sure you want to Cancel this Subscription<span>{'?'}</span>
        </div>
        <Form layout='vertical' onFinish={onCancelSubmit}>
          <Form.Item
            name='reason'
            label='Reason'
            className='customInput mobileInputView steric-after'
            rules={[
              {
                required: true,
                message: 'Reason is required',
              },
              {
                validator: (_, value) => {
                  if (!value) return Promise.resolve();
                  const regex = /^[^%?{}[\]$^*@<>]*$/;
                  if (regex.test(value)) {
                    return Promise.resolve();
                  } else {
                    return Promise.reject('Value contains invalid special characters');
                  }
                },
              },
            ]}>
            <Input type='string' placeholder='Enter Reason' name='reason' />
          </Form.Item>
          <Form.Item>
            <div className='flex popupConfirmBtn'>
              <Button
                onClick={() => {
                  setCancelSubscriptionModal(false);
                }}
                block
                className='rounded-lg bg-plain'>
                Cancel
              </Button>
              <Button className='DeleteBtn ml-4 rounded-lg' block htmlType='submit' loading={isSubscriptionCanceling}>
                Confirm
              </Button>
            </div>
          </Form.Item>
        </Form>
      </Modal>
      <Modal
        className='pause-modal'
        open={resumeSubscriptionModal}
        width={400}
        onCancel={() => {
          setResumeSubscriptionModal(false);
        }}
        footer={false}
        okButtonProps={{ loading: isSubscriptionResuming }}
        destroyOnClose>
        <header className='font-semibold text-base mb-4'>Resume Subscription</header>
        <div className='mb-4'>
          Are you sure you want to resume this Subscription<span>{'?'}</span>
        </div>
        <div className='mb-6'>
          <Radio.Group className='radio-group' value={selectedCycle} onChange={handleRadioChange}>
            <Radio value='retain'>Same Billing Cycle</Radio>
            <Radio value='now'>New Billing Cycle</Radio>
          </Radio.Group>
        </div>
        <div className='flex mt-4 popupConfirmBtn'>
          <Button
            onClick={() => {
              setResumeSubscriptionModal(false);
            }}
            block
            className='rounded-lg bg-plain'>
            Cancel
          </Button>
          <Button className='primaryBtn ml-4 rounded-lg' block onClick={() => handleResumeSubscription(record?.subscription_id)} loading={isSubscriptionResuming}>
            Confirm
          </Button>
        </div>
      </Modal>
      <Modal
        className='pause-modal'
        open={pauseSubscriptionModal}
        width={400}
        onCancel={() => {
          setPauseSubscriptionModal(false);
        }}
        footer={false}
        okButtonProps={{ loading: isSubscriptionPausing }}
        destroyOnClose>
        <header className='font-semibold text-base mb-4'>Pause Subscription</header>
        <div className='mb-8'>
          Are you sure you want to pause this Subscription<span>{'?'}</span>
        </div>
        <div className='flex mt-4 popupConfirmBtn'>
          <Button
            onClick={() => {
              setPauseSubscriptionModal(false);
            }}
            block
            className='rounded-lg bg-plain'>
            Cancel
          </Button>
          <Button className='DeleteBtn ml-4 rounded-lg' block onClick={() => handlePauseSubscription(record?.subscription_id)} loading={isSubscriptionPausing}>
            Confirm
          </Button>
        </div>
      </Modal>
      <Modal
        className='bin-modal'
        open={paymentRetryModal}
        centered
        width={400}
        onCancel={() => {
          setpaymentRetryModal(false);
        }}
        footer={false}
        okButtonProps={{ loading: isPaymentRetrying }}
        destroyOnClose>
        <header className='font-semibold text-base mb-4'>Retry Payment</header>
        <div className='mb-8'>
          Are you sure you want to retry payment on this invoice ID<span> {'?'}</span>
          <span>{invoiceId || 'N/A'}</span>
          {store?.subscription?.send_payment_link_on_inactive && record?.payment?.token_type !== 'wallet' && (
            <Form.Item className='customInput mobileInputView checked-label'>
              <Checkbox onChange={handlePriceChange} style={{ marginTop: '16px', fontWeight: '500' }}>
                Send Payment Link on Failure
              </Checkbox>
            </Form.Item>
          )}
        </div>
        <div className='flex mt-4 popupConfirmBtn'>
          <Button
            onClick={() => {
              setpaymentRetryModal(false);
            }}
            block
            className='rounded-lg bg-plain'>
            Cancel
          </Button>
          <Button className='ml-4 primaryBtn rounded-lg' block onClick={() => handleRetryPayment()} loading={isPaymentRetrying}>
            Confirm
          </Button>
        </div>
      </Modal>
      <Modal
        className='bin-modal'
        open={rejectInvoiceModal}
        centered
        width={400}
        onCancel={() => {
          setRejectInvoiceModal(false);
        }}
        footer={false}
        okButtonProps={{ loading: isPaymentRejecting }}
        destroyOnClose>
        <header className='font-semibold text-base mb-4'>Reject Payment</header>
        <div className='mb-8'>
          Are you sure you want to reject this invoice ID<span> {'?'}</span>
          <span>{invoiceId || 'N/A'}</span>
        </div>
        <div className='flex mt-4 popupConfirmBtn'>
          <Button
            onClick={() => {
              setRejectInvoiceModal(false);
            }}
            block
            className='rounded-lg bg-plain'>
            Cancel
          </Button>
          <Button className='ml-4 primaryBtn rounded-lg' block onClick={() => handleRejectPayment()} loading={isPaymentRejecting}>
            Confirm
          </Button>
        </div>
      </Modal>
      <Modal
        className='bin-modal'
        open={payModal}
        centered
        width={400}
        onCancel={() => {
          setPayModal(false);
        }}
        footer={false}
        okButtonProps={{ loading: isPaying }}
        destroyOnClose>
        <header className='font-semibold text-base mb-4'>Pay</header>
        <div className='mb-8'>
          Are you sure you want to pay this invoice ID<span> {'?'}</span>
          <span>{invoiceId || 'N/A'}</span>
          {store?.subscription?.send_payment_link_on_inactive && (
            <Form.Item className='customInput mobileInputView checked-label'>
              <Checkbox onChange={handlePriceChange} style={{ marginTop: '16px', fontWeight: '500' }}>
                Send Payment Link on Failure
              </Checkbox>
            </Form.Item>
          )}
        </div>
        <div className='flex mt-4 popupConfirmBtn'>
          <Button
            onClick={() => {
              setPayModal(false);
            }}
            block
            className='rounded-lg bg-plain'>
            Cancel
          </Button>
          <Button className='ml-4 primaryBtn rounded-lg' block onClick={() => handlePay()} loading={isPaying}>
            Confirm
          </Button>
        </div>
      </Modal>
      <Modal
        className='bin-modal'
        open={refundModal}
        centered
        width={400}
        onCancel={() => {
          setRefundModal(false);
        }}
        footer={false}
        okButtonProps={{ loading: isRefunding }}
        destroyOnClose>
        <header className='font-semibold text-base mb-4'>Refund</header>
        <div className='mb-8'>
          Are you sure you want to refund this invoice ID<span> {'?'}</span>
          <span>{invoiceId || 'N/A'}</span>
        </div>
        <div className='flex mt-4 popupConfirmBtn'>
          <Button
            onClick={() => {
              setRefundModal(false);
            }}
            block
            className='rounded-lg bg-plain'>
            Cancel
          </Button>
          <Button className='ml-4 primaryBtn rounded-lg' block onClick={() => handleRefund()} loading={isRefunding}>
            Confirm
          </Button>
        </div>
      </Modal>
      <Modal
        className='bin-modal'
        centered
        open={skipSubscriptionModal}
        width={400}
        onCancel={() => {
          setSkipSubscriptionModal(false);
        }}
        footer={false}
        okButtonProps={{ loading: isSubscriptionSkiping }}
        destroyOnClose>
        <header className='font-semibold text-base mb-4'>Skip Subscription Invoice</header>
        <div className='mb-8'>
          Are you sure you want to skip this Subscription Invoice<span>{'?'}</span>
        </div>
        <div className='flex mt-4 popupConfirmBtn'>
          <Button
            onClick={() => {
              setSkipSubscriptionModal(false);
            }}
            block
            className='rounded-lg bg-plain'>
            Cancel
          </Button>
          <Button className='DeleteBtn ml-4 rounded-lg' block onClick={() => handleSkipSubscription(record?.subscription_id)} loading={isSubscriptionSkiping}>
            Confirm
          </Button>
        </div>
      </Modal>
      <Modal
        className='bin-modal'
        open={processNowSubsModal}
        centered
        width={420}
        onCancel={() => {
          setProcessNowSubsModal(false);
        }}
        footer={false}
        okButtonProps={{ loading: isPaying }}
        destroyOnClose>
        <header className='font-semibold text-base mb-4'>Process Now Invoice</header>
        <div className='mb-8'>
          Are you sure you want to "Process Now" this invoice<span> {'?'}</span>
          <span>{invoiceId || 'N/A'}</span>
          {store?.subscription?.send_payment_link_on_inactive && record?.payment?.token_type !== 'wallet' && (
            <Form.Item className='customInput mobileInputView checked-label'>
              <Checkbox onChange={handlePriceChange} style={{ marginTop: '16px', fontWeight: '500' }}>
                Send Payment Link on Failure
              </Checkbox>
            </Form.Item>
          )}
        </div>
        <div className='flex mt-4 popupConfirmBtn'>
          <Button
            onClick={() => {
              setProcessNowSubsModal(false);
            }}
            block
            className='rounded-lg bg-plain'>
            Cancel
          </Button>
          <Button className='ml-4 primaryBtn rounded-lg' block onClick={() => handlePay()} loading={isPaying}>
            Confirm
          </Button>
        </div>
      </Modal>
      <Modal
        className='bin-modal rescheduled-modal'
        open={rescheduledSubsModal}
        centered
        width={420}
        onCancel={() => setRescheduledSubsModal(false)}
        footer={false}
        okButtonProps={{ loading: isRescheduling }}
        destroyOnClose>
        <header className='font-semibold text-base mb-4'>Reschedule Invoice</header>
        <div className='mb-4'>
          Are you sure you want to Reschedule this invoice?
          <span>{invoiceId || 'N/A'}</span>
        </div>
        <Form layout='vertical' onFinish={onRescheduledSubmit}>
          <Form.Item
            className='formFields formFieldsOne customFont steric-after'
            name='rescheduled_Date'
            label='New Date'
            rules={[
              {
                required: true,
                message: 'Date is required',
              },
            ]}>
            <DateTimePicker />
          </Form.Item>
          <Form.Item>
            <div className='flex mt-4 popupConfirmBtn'>
              <Button onClick={() => setRescheduledSubsModal(false)} block className='rounded-lg bg-plain'>
                Cancel
              </Button>
              <Button className='ml-4 primaryBtn rounded-lg' block htmlType='submit' loading={isRescheduling}>
                Confirm
              </Button>
            </div>
          </Form.Item>
        </Form>
      </Modal>
      <Modal
        className='bin-modal'
        centered
        open={unskipSubscriptionModal}
        width={400}
        onCancel={() => {
          setUnskipSubscriptionModal(false);
        }}
        footer={false}
        okButtonProps={{ loading: isSubscriptionUnskiping }}
        destroyOnClose>
        <header className='font-semibold text-base mb-4'>Unskip Subscription Invoice</header>
        <div className='mb-4'>
          Are you sure you want to Unskip this Subscription Invoice<span>{'?'}</span>
        </div>
        {dateComparisionWithCurrent(unskipInvoiceValue?.date) && (
          <div>
            <h3 style={{ fontWeight: '800' }}>Allow for past date</h3>
            <Switch defaultChecked={overrideValue} checked={overrideValue} onChange={onChange} />
            <h2 className='mt-2'>If the above check is true then payment will be done immediately.</h2>
          </div>
        )}
        <div className='flex mt-4 popupConfirmBtn'>
          <Button
            onClick={() => {
              setUnskipSubscriptionModal(false);
            }}
            block
            className='rounded-lg bg-plain'>
            Cancel
          </Button>
          <Button className='DeleteBtn ml-4 rounded-lg' block onClick={() => handleUnskipSubscription(record?.subscription_id)} loading={isSubscriptionUnskiping}>
            Confirm
          </Button>
        </div>
      </Modal>
      {checkUserPermissions([USER_ROLES.XPAY_ADMIN, USER_ROLES.XPAY_RESTRICTED_ADMIN, USER_ROLES.XPAY_SUBSCRIPTION_USER]) && (
        <div className={`flex items-center gap-4 ${isLoading || record ? 'footer footer-action-button' : ''}`}>
          {isLoading ? (
            <div style={{ display: 'flex', justifyContent: 'center', gap: '20px' }} className='subscription-button'>
              <Skeleton.Input active style={{ marginTop: '0' }} className='first-button' />
              <Skeleton.Input active style={{ marginTop: '0' }} className='second-button' />
            </div>
          ) : (
            record && (
              <>
                {record?.state !== 'cancelled' && (
                  <div
                    className='table-action-btn flex items-center justify-center'
                    onClick={() => {
                      setCancelSubscriptionModal(true);
                    }}
                    style={{ cursor: 'pointer' }}>
                    Cancel Subscription
                  </div>
                )}
                {record?.state !== 'paused' && record?.state !== 'cancelled' && (
                  <div
                    type='primary'
                    className='table-action-btn'
                    onClick={() => {
                      setPauseSubscriptionModal(true);
                    }}
                    style={{ cursor: 'pointer' }}>
                    Pause Subscription
                  </div>
                )}
                {record?.state === 'paused' && (
                  <div
                    type='primary'
                    className='table-action-btn'
                    onClick={() => {
                      setResumeSubscriptionModal(true);
                    }}
                    style={{ cursor: 'pointer' }}>
                    Resume Subscription
                  </div>
                )}

                <div
                  type='primary'
                  className='table-action-btn'
                  onClick={() => {
                    handleWebhookTrigger();
                  }}
                  style={{ cursor: 'pointer' }}>
                  Trigger Webhook
                </div>
              </>
            )
          )}
        </div>
      )}
    </>
  );
};
